import { SxProps, Theme } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { useNavigate } from 'react-router-dom';

import { constants } from 'appConstants';
import { ChatBvLogoButton } from 'components/DeepSearch/components/components';

type BrandLogoChatProps = {
  width?: string;
  height?: string;
  margin?: string;
  sx?: SxProps<Theme>;
};

export const BrandLogoChat = ({
  width,
  height,
  margin,
  sx,
}: BrandLogoChatProps) => {
  const {
    session: { account },
  } = useSession();
  const redirect = useNavigate();
  const { images } = constants;

  function handleBrandLogoClick() {
    if (account?.account?.user_info?.noncompliant) {
      return null;
    }
    redirect('/dashboard');
  }
  return (
    <ChatBvLogoButton
      disableRipple
      sx={{
        width,
        height,
        margin,
        ...sx,
      }}
      onClick={handleBrandLogoClick}
      data-testid="brand-logo-btn"
    >
      <img
        src={images.brandLogo}
        alt="brand logo"
        width={width}
        height={height}
      />
    </ChatBvLogoButton>
  );
};
